import { useSyncExternalStore } from 'react';
import { DataFilterDefinitionsDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { useQueryClient } from '@tanstack/react-query';

import {
  findCachedPageFilterDefinitions,
  isPageFilterQueryKeyForInstance,
} from '../utils/comparisonDetailPageNav';

export function useReactiveCachedPageFilterDefinitions(
  pageFilterInstanceId: string | null | undefined
): DataFilterDefinitionsDtoResponse['data'] | undefined {
  const queryClient = useQueryClient();

  return useSyncExternalStore(
    (onStoreChange) =>
      queryClient.getQueryCache().subscribe((event) => {
        if (
          event.type !== 'updated' &&
          event.type !== 'added' &&
          event.type !== 'removed'
        ) {
          return;
        }

        if (
          isPageFilterQueryKeyForInstance(
            event.query.queryKey,
            pageFilterInstanceId
          )
        ) {
          onStoreChange();
        }
      }),
    () => findCachedPageFilterDefinitions(queryClient, pageFilterInstanceId),
    () => findCachedPageFilterDefinitions(queryClient, pageFilterInstanceId)
  );
}
